import React, { memo } from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/styles";
import { IconTooltip } from "@metacrm/metacrm-material-ui/dist/IconTooltip";
import BarChart from "./BarChart";
import LineChart from "./LineChart";
import PieChart from "./PieChart";
import HeatMap from "./HeatMap";
import TagCloudComponent from "./TagCloud";
import Top10Table from "./Top10Table";
import { Loading } from "features/common";

const ChartContainer = ({
  title,
  tooltipText,
  height = "330px",
  chartStyle = "bar",
  children,
  chartData,
  isLoading,
  heatColor,
  type,
  context,
  options,
  actions,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: height,
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}>
      <Box
        sx={{
          fontSize: 16,
          fontWeight: 500,
          color: theme.customColors.grey[700],
          marginBottom: chartStyle !== "table" && title ? "20px" : 0,
          display: "flex",
          alignItems: "center",
        }}>
        {chartStyle !== "table" && (
          <>
            {title}

            {tooltipText && (
              <IconTooltip
                sx={{
                  marginLeft: "4px",
                }}
                content={tooltipText}></IconTooltip>
            )}

            <Box ml={"auto"}>{children}</Box>
          </>
        )}
      </Box>
      {isLoading ? (
        <Box sx={{ position: "relative", height: "100%" }}>
          <Loading open={true} fullScreen={false} isChart={true} />
        </Box>
      ) : (
        <>
          {chartStyle === "bar" && <BarChart chartData={chartData}></BarChart>}
          {chartStyle === "line" && (
            <LineChart chartData={chartData} options={options}></LineChart>
          )}
          {chartStyle === "heatmap" && (
            <HeatMap
              chartData={chartData}
              heatColor={heatColor}
              context={context}></HeatMap>
          )}
          {chartStyle === "tagCloud" && (
            <TagCloudComponent
              chartData={chartData}
              fetchMentionsDetail={actions?.fetchMentionsDetail}
              type={type}
              handleExclude={actions?.handleExclude}
            />
          )}
          {chartStyle === "pie" && <PieChart chartData={chartData}></PieChart>}
          {chartStyle === "table" && (
            <Top10Table
              chartData={chartData}
              isLoading={isLoading}
              fetchMentionsDetail={actions?.fetchMentionsDetail}
              type={type}
              handleExclude={actions?.handleExclude}></Top10Table>
          )}
        </>
      )}
    </Box>
  );
};

export default memo(ChartContainer);
